import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import {
    ORFButton,
    ORFSearchSuggestions as SearchSuggestions
} from '../../../../../../common/forms/order-request-form.component';
import { newCircuitSubscriptionActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-subscription.reducer";
import { createRequestActions } from "./../../../../../../../store/external/request-reducer/create-request.reducer";
import { requestDetailsActions } from "./../../../../../../../store/external/request-reducer/request-details.reducer";
import './wireline-location-form.component.css';
import { InputFieldFloatingLabel as InputField } from '../../../../../../common/custom-form/select-filter.component';
import CustomSearchableSelectWrapper from '../../../../../../common/custom-form/custom-searchable-select-wrapper.component';
import { MAX_LENGTH } from '../../../../../../../constants/external-constants';
import { Loading } from '../../../../../../common/loading';
import CustomSearchableDropdownWrapper from "../../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";

class NewCircuitLocationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showComponent: false,
            isLoading: false,
        }
    }

    componentDidMount() {
        const { firstLoad } = this.props.newCircuitRequest;
        const { isUpdate } = this.props;
        if (firstLoad && !isUpdate) {
            this.setState({ isLoading: true });
            this.props.resetNewCircuitForm();
            this.props.getNewCircuitFormData().then(()=>{
                this.setState({isLoading:false});
                this.props.onSetFirstLoad(false);
            });
        }
        if(firstLoad && isUpdate)
        {
            this.setState({
                isLoading:true
            });
            this.props.getNewCircuitFormData().then(()=>{
                this.setState({isLoading:false});
            });
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    };

    onClickNext = () =>{
        this.props.nextAction();
    };

    handleCountrySearch = (query) => {
        this.props.getAllCountries(1, query);
    };

    loadMoreCountry = (searchString) => {
        const { newCircuitRequest } = this.props;
        this.props.getAllCountries(newCircuitRequest.countryPage + 1, searchString);
    };

    handleDeliveryAddress1Search = (query) => {
        const { wirelineLocationFormA } = this.props;

        if (!wirelineLocationFormA) return;

        const countryCode = wirelineLocationFormA.country;
        if (!countryCode) return;

        this.props.getDeliveryAddress1DropdownAsync(countryCode, 1, query);
    };

    loadMoreDeliveryAddress1 = (searchString = '') => {
        const { newCircuitRequest, wirelineLocationFormA } = this.props;
        const { deliveryAddress1Page = 1 } = newCircuitRequest;

        if (!wirelineLocationFormA.country) return;

        const nextPage = deliveryAddress1Page + 1;

        this.props.getDeliveryAddress1DropdownAsync(wirelineLocationFormA.country, nextPage, searchString);
    };

    handleDeliveryAddress2Search = (query) => {
        const { wirelineLocationFormA } = this.props;

        if (!wirelineLocationFormA) return;

        const countryCode = wirelineLocationFormA.country;
        if (!countryCode) return;

        this.props.getDeliveryAddress2DropdownAsync(countryCode, 1, query);
    };

    loadMoreDeliveryAddress2 = (searchString = '') => {
        const { newCircuitRequest, wirelineLocationFormA } = this.props;
        const { deliveryAddress2Page = 1 } = newCircuitRequest;

        if (!wirelineLocationFormA.country) return;

        const nextPage = deliveryAddress2Page + 1;

        this.props.getDeliveryAddress2DropdownAsync(wirelineLocationFormA.country, nextPage, searchString);
    };

    render() {
        const {
            onClickCancel,
            wirelineLocationFormA,
            onCountrySelect,
            onBillingAddressSelect,
            fetchAddressByValue,
            onLocationAddress1Select,
            onLocationAddress2Select
        } = this.props;

        const { isRequestOnBehalf, requestOnBehalfData, addressList } = this.props.createRequest;
        const { countryOptions, addressOptions, address1Options, address2Options, firstLoad, isCountryLoading, hasMoreCountry, isDeliveryAddress1Loading, hasMoreDeliveryAddress1, isDeliveryAddress2Loading, hasMoreDeliveryAddress2 } = this.props.newCircuitRequest;


        let isROB = isRequestOnBehalf && (requestOnBehalfData.EmployeeId === '' || requestOnBehalfData.EmployeeId === 0)
        let disableNextButton = wirelineLocationFormA.countryCode === ''
            || !wirelineLocationFormA.locationAddressId
            || isROB;
        if(this.state.isLoading && firstLoad) {
            return <Loading />
        }

        if(this.state.isLoading) {
            return <Loading />
        }

        return (
            <div>
                <Form method="post" role="form"
                    model="wirelineLocationFormA"
                    onSubmit={this.onClickNext}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12} className='custom-margin custom-wrapper-plan'>
                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('country')}`}
                                options={countryOptions}
                                selected={wirelineLocationFormA.countryCode}
                                onChange={(e) => onCountrySelect('wirelineLocationFormA.countryCode', e)}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.countryCode'
                                maxLength={MAX_LENGTH.limit_100}
                                isRequiredButNullable={true}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                onSearchChange={this.handleCountrySearch}
                                onLoadMore={this.loadMoreCountry}
                                isLoading={isCountryLoading}
                                hasMore={hasMoreCountry}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='custom-margin'>
                            <SearchSuggestions
                                value={wirelineLocationFormA.billingAddress}
                                label={`${this.toLocaleLanguage('billing_address')}`}
                                propDisplay={'LocationName'}
                                options={addressList.length > 0 ? addressList : ''}
                                onChangeAction={onBillingAddressSelect}
                                searchAction={fetchAddressByValue}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                maxLength={MAX_LENGTH.limit_1000}
                                disabled={wirelineLocationFormA.countryCode === ''}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='address-container'>
                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('location_address')}`}
                                options={address1Options?.filter(item => item.Key < 0 || item?.Value.trim().length > 15)}
                                selected={wirelineLocationFormA.locationAddressId}
                                onChange={(e) => onLocationAddress1Select('wirelineLocationFormA.locationAddress',e)}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.locationAddressId'
                                maxLength={MAX_LENGTH.limit_100}
                                isRequiredButNullable={true}
                                disabled={wirelineLocationFormA.countryCode === '' || addressOptions.length === 0}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                onSearchChange={this.handleDeliveryAddress1Search}
                                onLoadMore={this.loadMoreDeliveryAddress1}
                                isLoading={isDeliveryAddress1Loading}
                                hasMore={hasMoreDeliveryAddress1}  
                            />
                            {
                                (wirelineLocationFormA.locationAddress !== '' && wirelineLocationFormA.locationAddressId !== '') &&
                                <div className="request-details-container custom-details">
                                    {wirelineLocationFormA.locationAddress}
                                </div>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='no-border'>
                            <InputField
                                className="form-control"
                                type="text"
                                label={`${this.toLocaleLanguage('demarc_location')}`}
                                value={wirelineLocationFormA.demarcLocation}
                                fieldProp='.demarcLocation'
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                disabled={wirelineLocationFormA.countryCode === ''}
                                maxLength={MAX_LENGTH.limit_255}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='address-container'>
                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('location_address_p2p')}`}
                                options={address2Options}
                                selected={wirelineLocationFormA.locationAddressPTPId}
                                onChange={(e) => onLocationAddress2Select('wirelineLocationFormA.locationAddressP2P',e)}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.locationAddressPTPId'
                                maxLength={MAX_LENGTH.limit_100}
                                disabled={addressOptions.length === 0 || wirelineLocationFormA.countryCode === ''}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                onSearchChange={this.handleDeliveryAddress2Search}
                                onLoadMore={this.loadMoreDeliveryAddress2}
                                isLoading={isDeliveryAddress2Loading}
                                hasMore={hasMoreDeliveryAddress2}  
                            />
                            {
                                (wirelineLocationFormA.locationAddressP2P !== '' && wirelineLocationFormA.locationAddressPTPId !== '') &&
                                <div className="request-details-container custom-details">
                                    {wirelineLocationFormA.locationAddressP2P}
                                </div>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='no-border'>
                            <InputField
                                className="form-control"
                                type="text"
                                label={`${this.toLocaleLanguage('demarc_location_ptp')}`}
                                value={wirelineLocationFormA.demarcLocationPTP}
                                fieldProp='.demarcLocationPTP'
                                disabled={wirelineLocationFormA.countryCode === ''}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                maxLength={MAX_LENGTH.limit_255}
                            />
                        </Col>
                    </Row>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('next_button')}
                                    variant={"primary"}
                                    type={"submit"}
                                    disabled={disableNextButton}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
}

export default connect(
    state => {
        const { newCircuitRequest, createRequest, translation } = state;
        const { wirelineLocationFormA } = state.form;
        return {
            newCircuitRequest
            , wirelineLocationFormA
            , createRequest
            , ...translation,
        };
    }
    , dispatch =>
        bindActionCreators(
        Object.assign({}, newCircuitSubscriptionActions, createRequestActions, requestDetailsActions),
        dispatch
    )
)(NewCircuitLocationForm);